import { useRef } from "react";

const ContentVideoAi = () => {
  const data = [
    {
      title: "T2V",
      links: [
        {
          link: "https://backend.whalesai.com/public/hiwvideos/t2v-video-ai-veo.mp4",
          model: "Veo 3.1"
        },
        {
          link: "https://backend.whalesai.com/public/hiwvideos/t2v-video-ai-kling.mp4",
          model: "Kling V3.0 Pro"
        },
        {
          link: "https://backend.whalesai.com/public/hiwvideos/t2v-video-ai-veo-lite.mp4",
          model: "Veo 3.1 Lite"
        },
        {
          link: "https://backend.whalesai.com/public/hiwvideos/t2v-video-ai-seedance.mp4",
          model: "Seedance 2.5"
        },

        {
          link: "https://backend.whalesai.com/public/hiwvideos/t2v-video-ai-veo-fast.mp4",
          model: "Veo 3.1 Fast"
        },
        {
          link: "https://backend.whalesai.com/public/hiwvideos/t2v-video-ai-wan.mp4",
          model: "Wan 2.7"
        },
        {
          link: "https://backend.whalesai.com/public/hiwvideos/t2v-video-ai-wan-3.mp4",
          model: "Wan 3.0"
        },

      ],
      level: "TEXT TO VIDEO",
      prompt: "A majestic dragon perched on a mountain peak, with wings spread wide, scales shimmering, and a panoramic view of the kingdom below."
    },
    {
      title: "I2V",
      links: [
        {
          link: "https://backend.whalesai.com/public/hiwvideos/i2v-video-ai-veo.mp4",
          model: "Veo 3.1"
        },
        {
          link: "https://backend.whalesai.com/public/hiwvideos/i2v-video-ai-kling.mp4",
          model: "Kling V3.0 Pro"
        },
        {
          link: "https://backend.whalesai.com/public/hiwvideos/i2v-video-ai-seedance.mp4",
          model: "Seedance 2.5"
        },
        {
          link: "https://backend.whalesai.com/public/hiwvideos/i2v-video-ai-veo-fast.mp4",
          model: "Veo 3.1 Fast"
        },
        {
          link: "https://backend.whalesai.com/public/hiwvideos/i2v-video-ai-wan.mp4",
          model: "Wan 2.7"
        },
        {
          link: "https://backend.whalesai.com/public/hiwvideos/i2v-video-ai-wan-3.mp4",
          model: "Wan 3.0"
        }
      ],
      level: "IMAGE TO VIDEO",
      prompt: "A cozy café in Paris with outdoor seating, people enjoying coffee and pastries, and the Eiffel Tower in the distance.",
      promptImage1: "/video-ai-prompt-sample-1.png"
    },
    {
      title: "FRAMES",
      // https://backend.whalesai.com/public/hiwvideos/frames-video-ai-veo.mp4
      // https://backend.whalesai.com/public/hiwvideos/frames-video-ai-veo-lite.mp4
      // https://backend.whalesai.com/public/hiwvideos/frames-video-ai-veo-fast.mp4
      links: [
        {
          link: "https://backend.whalesai.com/public/hiwvideos/frames-video-ai-wan.mp4",
          model: "Wan 2.7"
        },
        {
          link: "https://backend.whalesai.com/public/hiwvideos/frames-video-ai-seedance.mp4",
          model: "Seedance 2.5"
        },
        {
          link: "https://backend.whalesai.com/public/hiwvideos/frames-video-ai-kling.mp4",
          model: "Kling V3.0 Pro"
        },
        {
          link: "https://backend.whalesai.com/public/hiwvideos/frames-video-ai-veo.mp4",
          model: "Veo 3.1"
        },
        {
          link: "https://backend.whalesai.com/public/hiwvideos/frames-video-ai-veo-lite.mp4",
          model: "Veo 3.1 Lite"
        },
        {
          link: "https://backend.whalesai.com/public/hiwvideos/frames-video-ai-veo-fast.mp4",
          model: "Veo 3.1 Fast"
        }
      ],
      level: "FRAME INTERPOLATION",
      prompt: "A cozy cabin in the woods with smoke rising from the chimney, a stack of firewood, and a snowy landscape all around.",
      promptImage1: "/video-ai-prompt-sample-2.png",
      promptImage2: "/video-ai-prompt-sample-3.png"
    },
  ];

  const videoRefs = useRef({});

  const handlePlay = (key) => {
    Object.keys(videoRefs.current).forEach((k) => {
      if (k !== key && videoRefs.current[k]) {
        videoRefs.current[k].pause();
      }
    });
  };

  return (
    <div className="text-white">
      <style>{`
        .video-horizontal-scroll::-webkit-scrollbar {
          height: 10px;
        }
        .video-horizontal-scroll::-webkit-scrollbar-track {
          background: rgba(255, 255, 255, 0.05);
          border-radius: 8px;
        }
        .video-horizontal-scroll::-webkit-scrollbar-thumb {
          background: rgba(255, 255, 255, 0.2);
          border-radius: 8px;
          border: 2px solid transparent;
          background-clip: padding-box;
        }
        .video-horizontal-scroll::-webkit-scrollbar-thumb:hover {
          background-color: rgba(255, 255, 255, 0.4);
        }
        @media (max-width: 768px) {
          .video-horizontal-scroll::-webkit-scrollbar {
            display: none;
          }
        }
      `}</style>
      <div>
        {data.map((video, index) => (
          <div key={index} className="text-center mt-5">
            {video.level && <h4>{video.level}</h4>}

            {video.prompt && (
              <p className="mt-3 px-3 text-center">
                <span className="fw-bold">Prompt:</span> {video.prompt}
              </p>
            )}

            {(video.promptImage1 || video.promptImage2) && (
              <div className="d-flex justify-content-center gap-4 flex-wrap mt-3 px-3">
                {video.promptImage1 && (
                  <div className="d-flex flex-column align-items-center">
                    <p className="fw-bold mb-2">{video.promptImage2 ? "Input Image 1" : "Input Image"}</p>
                    <img
                      src={video.promptImage1}
                      alt="Input 1"
                      className="img-fluid rounded shadow-sm"
                      style={{ width: "100%", maxWidth: "400px", height: "auto", objectFit: "cover" }}
                    />
                  </div>
                )}
                {video.promptImage2 && (
                  <div className="d-flex flex-column align-items-center">
                    <p className="fw-bold mb-2">Input Image 2</p>
                    <img
                      src={video.promptImage2}
                      alt="Input 2"
                      className="img-fluid rounded shadow-sm"
                      style={{ width: "100%", maxWidth: "400px", height: "auto", objectFit: "cover" }}
                    />
                  </div>
                )}
              </div>
            )}

            <div
              style={{
                marginBlock: "20px",
                display: "flex",
                overflowX: "auto",
                gap: "20px",
                paddingBottom: "15px",
                scrollSnapType: "x mandatory"
              }}
              className="mx-auto w-100 px-3 video-horizontal-scroll"
            >
              {video.links.map((item, j) => (
                <div
                  key={j}
                  className="d-flex gap-2 flex-column justify-content-center align-items-center flex-shrink-0"
                  style={{ width: "90%", maxWidth: "800px", scrollSnapAlign: "center", margin: "0 auto" }}
                >
                  <video
                    controls
                    playsInline
                    src={item.link}
                    className="shadow"
                    style={{ width: "100%", borderRadius: "10px" }}
                    type="video/mp4"
                    ref={(el) => (videoRefs.current[`${index}-${j}`] = el)}
                    onPlay={() => handlePlay(`${index}-${j}`)}
                  />
                  <p className="mt-2 fw-bold text-light mb-0" style={{ fontSize: "16px" }}>{item.model}</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContentVideoAi;
